export default [
  [`Европейские`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российские`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
  [`В груди, полуобхват (см)`, `52`, `54`, `56`, `58`, `60`, `62`],
  [`Длина (см)`, `69`, `71`, `72`, `74`, `75`, `77`],
];
